<template>
  <main id="help-dashboard" class="site-main">
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell">
          <article>
            <h1>Setting Up Vendors</h1>

            <div class="grid-x grid-padding-x">
              <div class="cell large-auto small-order-2 large-order-1">
                <div class="panel">
                  <section id="step-1" class="help-section">
                    <h2 class="help-section__title">1. Vendor Name Tracking</h2>

                    <div class="help-section__details">
                      <p>Adding a product to your vendors is simple. Just add the vendor name in the
                        vendor name field within Shopify. Doing this will automatically connect the
                        product to your vendor within our app. If the vendor does not yet exist in
                        our app it will create it automatically for you.</p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/setting-up-vendors_1.jpg"
                           alt="Ensure your PayPal account is setup for business.">
                    </div>
                  </section>

                  <section id="step-2" class="help-section">
                    <h2 class="help-section__title">2. Product Tag Tracking</h2>

                    <div class="help-section__details">
                      <p>With product tag tracking you will set a product tag based off of your
                        chosen prefix (vendor_ by default). For example, if your vendor name is John
                        Doe then the tag should be "vendor_John Doe" Doing this will automatically
                        connect that product to your vendor within our app. If the vendor does not
                        yet exist in our app it will create it automatically for you.</p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/product-tag-tracking.jpg"
                           alt="Vendor Name Tracking">
                    </div>
                  </section>

                  <section id="step-3" class="help-section">
                    <h2 class="help-section__title">3. Verify vendors.</h2>

                    <div class="help-section__details">
                      <p>You should now see the vendor in your vendor list. If not please reach out
                        to us to help diagnose the issue.</p>

                      <p>If you need custom tracking in a different way, please reach out and we
                        will help get that setup.</p>
                    </div>
                  </section>
                </div>
              </div>

              <div class="cell large-shrink small-order-1 large-order-2"
                   data-sticky-container>
                <div class="sidebar sticky" style="min-width: 300px;">
                  <div class="panel">
                    <div class="panel__header">
                      <h2>Table of Contents</h2>
                    </div>

                    <div class="panel__content">
                      <ol class="table-of-contents">
                        <li @click="scrollTo('step-1')">Vendor Name Tracking</li>
                        <li @click="scrollTo('step-2')">Product Tag Tracking</li>
                        <li @click="scrollTo('step-3')">Verify vendors</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'settingUpVendors',
  components: {},
  created () {

  },
  methods: {
    scrollTo: function (destination) {
      document.getElementById(destination).scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../styles/variables';
@import '../../../styles/mixins';

.table-of-contents {
  li {
    cursor: pointer;
  }
}

.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 60px;
}

.help-section {
  margin-bottom: 45px;

  &__title {
    font-size: 18px;
  }

  &__details {
    margin-bottom: 15px;
    padding-left: 15px;
  }

  &__photo {
    margin-bottom: 15px;
    padding-left: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/help/articles/setting-up-vendors.vue